import {createSlice} from "@reduxjs/toolkit";


const initialReceiptManagementState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  searchingRcpt: false,
  verifiedReceipt: {},
  otpVerified: false,
  verifyingOTP: false,
  otpVerifiedResponse: {},
  sendingOTP: false,
  otpSent: {},
  updatedReceipt: {},
  receiptStatusUpdated: false,
  updatingRcptStat: false,
  reportDataStr: "",
  fetchingReport: false,
  receiptForEdit: undefined,
  error: null
};

export const callTypes = {
  list: "list",
  action: "action",
  findRcpt: "findRcpt",
  verifyOTP: "verifyOTP",
  sendOTP: "sendOTP",
  updateRcptStat: "updateRcptStat",
  fetchReportStr: "fetchReportString"
};
  

const receiptManagementSlice = createSlice({
  name: 'receiptManagement',
  initialState:initialReceiptManagementState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.findRcpt) {
        state.searchingRcpt = false;
      } else if (action.payload.callType === callTypes.sendOTP) {
        state.sendingOTP = false;
      } else if (action.payload.callType === callTypes.verifyOTP) {
        state.verifyingOTP = false;
      } else if (action.payload.callType === callTypes.updateRcptStat) {
        state.updatingRcptStat = false;
      } else if (action.payload.callType === callTypes.fetchReportStr) {
        state.fetchingReport = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if (action.payload.callType === callTypes.findRcpt) {
        state.searchingRcpt = true;
      } else if (action.payload.callType === callTypes.sendOTP) {
        state.sendingOTP = true;
      } else if (action.payload.callType === callTypes.verifyOTP) {
        state.verifyingOTP = true;
      } else if (action.payload.callType === callTypes.updateRcptStat) {
        state.updatingRcptStat = true;
      } else if (action.payload.callType === callTypes.fetchReportStr) {
        state.fetchingReport = true;
      } else {
        state.actionsLoading = true;
      }
    },
    receiptVerified: (state, action) => {
      const { receipt } = action.payload;
      state.actionsLoading = false;
      state.searchingRcpt = false;
      state.error = null;
      state.verifiedReceipt = receipt;
      state.listLoading = false;
    },
    verifiedReceiptCleared: (state, action) => {
      state.verifiedReceipt = {};
    },
    reset: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.verifiedReceipt = {};
      state.otpVerified = false;
      state.verifyingOTP = false;
      state.reportDataStr = "";
      state.fetchingReport = false;
      state.updatedReceipt = {};
      state.receiptStatusUpdated = false;
      state.updatingRcptStat = false;
    },
    verifyOTP: (state, action) => {
      state.otpVerifiedResponse = action.payload.res;
      if(action.payload.res.result.status === 200){
        state.otpVerified = true;
      } else {
        state.otpVerified = false;
      }
      state.verifyingOTP = false;
    },
    otpSent: (state, action) => {
      state.otpSent = action.payload.res;
      state.sendingOTP = false;
    },
    renderService: (state, action) => {
      state.updatedReceipt = action.payload.updatedReceipt;
      state.updatingRcptStat = false;
      state.receiptStatusUpdated = true;
    },
    fetchedReport: (state, action) => {
      state.reportDataStr = action.payload.reportStr;
      state.fetchingReport = false;
    }
  }
});

export const { actions } = receiptManagementSlice;
export const { reducer } = receiptManagementSlice;